import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () => import(/* webpackChunkName: 'Socials' */ './Socials'),
  loading: () => null,
});

export default class WithSocials extends React.Component {
  constructor() {
    super();
    this.state = { mounted: false };
  }
  componentDidMount() {
    this.setState({ mounted: true });
  }
  render() {
    return this.state.mounted ? <LoadableComponent {...this.props} /> : null;
  }
}
